import { useState } from 'react';
import { useFamilyStore } from '@/store/familyStore';
import { PersonalInfo } from '@/types';
import { api } from '@/lib/api/client';

export function useProfiles() {
  const { addPersonalInfo, updatePersonalInfo, deletePersonalInfo, fetchPersonalInfos } = useFamilyStore();
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [editingProfile, setEditingProfile] = useState<PersonalInfo | null>(null);
  const [deletingProfile, setDeletingProfile] = useState<PersonalInfo | null>(null);

  const handleAdd = async (data: Omit<PersonalInfo, 'id'>) => {
    try {
      const response = await api.post<PersonalInfo>('api/personal-info', data);
      addPersonalInfo(response);
      setShowAddDialog(false);
      // Refresh the list
      await fetchPersonalInfos();
    } catch (error) {
      console.error('Failed to add personal info:', error);
      throw error;
    }
  };

  const handleEdit = async (data: Omit<PersonalInfo, 'id'>) => {
    if (!editingProfile) return;
    
    try {
      await api.post(`api/personal-info/${editingProfile.id}`, data);
      updatePersonalInfo(editingProfile.id, data);
      setEditingProfile(null);
      // Refresh the list
      await fetchPersonalInfos();
    } catch (error) {
      console.error('Failed to update personal info:', error);
      throw error;
    }
  };

  const handleDelete = async () => {
    if (!deletingProfile) return;
    
    try {
      await api.delete(`api/personal-info/${deletingProfile.id}`);
      deletePersonalInfo(deletingProfile.id);
      setDeletingProfile(null);
      // Refresh the list
      await fetchPersonalInfos();
    } catch (error) {
      console.error('Failed to delete personal info:', error);
      throw error;
    }
  };

  return {
    showAddDialog,
    setShowAddDialog,
    editingProfile,
    setEditingProfile,
    deletingProfile,
    setDeletingProfile,
    handleAdd,
    handleEdit,
    handleDelete,
  };
}